<template>
  <div class="app-container">
    <list ref="list">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加合并工单</el-button>
        </template>
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="80">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="undo(row)">撤销</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/ticketmanagement/merge/list'
import editDialog from '@/components/production/ticketmanagement/merge/editDialog'

export default {
  name: "merge",
  mixins: [curdMixins],
  components: {
    list,
    editDialog
  },
  data(){
    return {
      api: require('@/api/production/workDoc').default,
    }
  },
  methods: {
    undo({WorkDocId}){
      this.api.revokeMergeWorkDoc({workDocId: WorkDocId}).then(res => {
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg})
          this.reload();
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
      })
    },
  }
  
};
</script>